import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloForm from '../components/TituloForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import TitulosPrintModal from "../relatorios/TitulosPrintModal";
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import LancamentosFinanceiros from '../tutoriais/LancLancamentosFinanceiros';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalTit: 0,
    qtdeTit: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    tipoTela: '',

    filtros: {
      tipoTela: 'TIT',
      buscaOrdem: { campo: 'tit_data_emissao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'X', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
      buscaCondPagto: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalTit: 0, qtdeTit: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaSituacao, buscaDescricao, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    // console.log('getListaRegistros: ', this.state.filtros);

    axios
      .get('/titulos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          tipo: buscaTipo.key,
          situacao: buscaSituacao.key,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          dataIni,
          dataFim,
          tipoTela: 'TIT'
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };


  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    // console.log('Registro gravar: ', registro);
    let request;
    if (registro.tit_idf) { //editar      
      request = axios.put(`/titulos/update/${registro.tit_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/titulos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onAdicionarClick = () => {
    axios.get(`/caixas/caixaAberto`, { params: { id: 0, cta: 0, data: '', situacao: 'X', } })
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            visualizar: false,
            tipoTela: '',
            dados: {
              tit_idf: 0,
              tit_controle: 0,
              tit_numero: 0,
              tit_tipo: { key: 'S', label: 'Saída', },
              tit_data_emissao: data && data.cx_data ? moment(data.cx_data).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
              tit_descricao: '',
              tit_pessoa: {
                key: '0',
                label: '',
              },
              tit_valor: 0,
              tit_tipo_doc: {
                key: String(this.state.usuario.par_doc_padrao),
                label: this.state.usuario.td_descricao,
              },
              tit_cond_pagto: {
                key: String(this.state.usuario.par_cond_pagto_padrao),
                label: this.state.usuario.td_descricao,
                qtdeParc: this.state.usuario.cp_qtde_parc,
                parcAVista: this.state.usuario.cp_parc_avista,
              },
              tit_plano_conta: {
                key: '0',
                label: '',
              },
              tit_cta_corrente: {
                key: String(this.state.usuario.par_cta_corrente_padrao),
                label: this.state.usuario.cc_descricao,
              },

              listaParcelas: [],
            }
          }
        })

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/titulos/show/${registro.tit_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('parcelas: ', data);

        data.dados.tit_pessoa = {
          key: String(data.dados.tit_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.tit_tipo_doc = {
          key: String(data.listaParcelas[0].tparc_tipo_doc),
          label: data.listaParcelas[0].td_descricao,
        }
        data.dados.tit_cond_pagto = {
          key: String(data.dados.tit_cond_pagto),
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.tit_plano_conta = {
          key: String(data.dados.tit_plano_conta),
          label: data.dados.pc_descricao,
        }
        data.dados.tit_cta_corrente = {
          key: String(data.listaParcelas[0].tparc_conta_corrente),
          label: data.listaParcelas[0].cc_descricao,
        }
        data.dados.tit_data_emissao = moment(data.dados.tit_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.tit_tipo = {
          key: data.dados.pc_tipo,
          label: data.dados.pc_tipo === 'E' ? 'Entrada' : 'Saída',
        }

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
            tipoTela: '',
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onDuplicarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/titulos/show/${registro.tit_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('parcelas: ', data);

        data.dados.tit_pessoa = {
          key: String(data.dados.tit_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.tit_tipo_doc = {
          key: String(data.listaParcelas[0].tparc_tipo_doc),
          label: data.listaParcelas[0].td_descricao,
        }
        data.dados.tit_cond_pagto = {
          key: String(data.dados.tit_cond_pagto),
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.tit_plano_conta = {
          key: String(data.dados.tit_plano_conta),
          label: data.dados.pc_descricao,
        }
        data.dados.tit_cta_corrente = {
          key: String(data.listaParcelas[0].tparc_conta_corrente),
          label: data.listaParcelas[0].cc_descricao,
        }
        data.dados.tit_data_emissao = moment(data.dados.tit_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.tit_tipo = {
          key: data.dados.pc_tipo,
          label: data.dados.pc_tipo === 'E' ? 'Entrada' : 'Saída',
        }

        data.dados.tit_idf = 0;
        data.dados.tit_controle = 0;
        data.dados.tit_numero = 0;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
            tipoTela: '',
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/titulos/delete/${registro.tit_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.tit_idf === registro.tit_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }

          })
      }
    })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
        buscaCondPagto: this.state.filtros.buscaCondPagto,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };





  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('TitulosPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('TitulosPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
        {getTemPermissao('TitulosPage', 'novo') ? (
          <Tooltip title="Duplicar">
            <Button type="ghost" size="small" onClick={() => this.onDuplicarClick(registro, false)} icon="folder-add" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };

  renderValor = (tit_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(tit_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderSituacao = (tit_situacao) => {
    if (tit_situacao === 'A') {
      return (
        <span>ABERTO</span>
      );
    } else if (tit_situacao === 'P') {
      return (
        <span>PAGO</span>
      );
    } else if (tit_situacao === 'F') {
      return (
        <span>FATURADO</span>
      );
    } else if (tit_situacao === 'C') {
      return (
        <span>CANCELADO</span>
      );
    }
  };

  renderTipo = (pc_tipo) => {
    if (pc_tipo === 'E') {
      return (
        <span>ENT</span>
      );
    } else if (pc_tipo === 'S') {
      return (
        <span>SAI</span>
      );
    }
  };

  renderNumero = (tit_numero, registro) => {
    return (
      <Tooltip title={'Nº Controle: ' + registro.tit_controle}>{tit_numero}</Tooltip>
    );
  };

  renderPessoa = (pes_nome, registro) => {
    return (
      <Tooltip title={'Código: ' + registro.tit_pessoa}>{pes_nome}</Tooltip>
    );
  };

  renderCtaFin = (pc_descricao, registro) => {
    return (
      <Tooltip title={'Código: ' + registro.tit_plano_conta}>{pc_descricao}</Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, formFiltroVisivel, salvando,
      registroSelecionado, filtros, total, pagina, limite } = this.state;

    // console.log('TitulosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Lançamentos Financeiros</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=19ewFo5Oqh8&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=8', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 50 }}>
            {getTemPermissao('TitulosPage', 'novo') ? (
              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAdicionarClick}
                  className="botao-primary"
                >
                  Adicionar
                </Button>
              </Col>
            ) : null}

            <Col xs={2} style={{ width: 110 }}>
              <Button
                type="primary"
                onClick={this.onAbrirFiltroClick}
                className="botao-primary"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>
            </Col>

            <Col xs={2} style={{ width: 110 }}>
              <TitulosPrintModal
                filtros={filtros}
                totalTit={this.state.totalTit}
                qtdeTit={this.state.qtdeTit}
              />
            </Col>

            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <TituloForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

            <LancamentosFinanceiros
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <div style={{ paddingTop: 0 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf)}
            >
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title={this.renderTitulo("Controle")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title={this.renderTitulo("Número")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={80}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_data_emissao"
                dataIndex="tit_data_emissao"
                title={this.renderTitulo("Emissão")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderData}
                width={120}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="tit_valor"
                dataIndex="tit_valor"
                title={this.renderTitulo("Valor")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="tit_situacao"
                dataIndex="tit_situacao"
                title={this.renderTitulo("Situação")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderSituacao}
                width={70}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title={this.renderTitulo("Cliente")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_tipo"
                dataIndex="pc_tipo"
                title={this.renderTitulo("Tipo")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderTipo}
                width={40}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_descricao"
                dataIndex="pc_descricao"
                title={this.renderTitulo("Conta Financeia")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title={this.renderTitulo("Descrição")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
                render={this.renderAcoes}
                width={120}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/TitulosPage.js